import { Dispatch } from "redux";
import { triggerNotification, Yup } from "../../../../../../../common/CommonExport";
import { storeAppraiserFeedback } from "../../../../../../../redux/slices/empEventsSlice";
interface DynamicValues {
  employeeReviewId: number | string;
  setLoader: (value: boolean) => void;
  getEmployeeReviewDetails: Function;
  handleReviewResponse: Function;
  dispatch: Dispatch;
  [key: string]: any;
}
export const appraisalValidationSchema = Yup.object().shape({
  reviewtype: Yup.string().required("This field is mandatory*"),
  salaryRevised: Yup.string().test("require-salaryRevised", "Salary Revised Date is required", function (value) {
    const incrementEligible = this.parent?.incrementEligible;
    if (incrementEligible === true && !value) {
      return this.createError({
        path: this.path,
        message: "Salary Revised Date is required",
      });
    }
    return true;
  }),
  probationExtension: Yup.string().test("require-probationExtension", "This field is mandatory*", function (value) {
    const reviewtype: any = this.parent.reviewtype;

    if (reviewtype === "Probation Extension" && !value) {
      return this.createError({
        path: this.path,
        message: "This field is mandatory",
      });
    }
    return true;
  }),
});

export const getEmpReviewsDetails = async ({ employeeReviewId, setLoader, getEmployeeReviewDetails, handleReviewResponse, dispatch }: DynamicValues) => {
  if (employeeReviewId) {
    const pathParams: any = {
      id: employeeReviewId,
      end: "detail",
    };
    setLoader(true);
    await getEmployeeReviewDetails("", "", pathParams)
      .then((response: any) => {
        const apiRes: any = response.data?.data?.employeeReviewDetails;
        const apprasialFeedback = apiRes.APPRAISER_FEEDBACK;
        let feedbackItems = {
          significantachievements: null,
          improvementareas: null,
          technicalskills: null,
          softskills: null,
          appraisercomments: null,
        };
        apprasialFeedback?.length > 0 &&
          apprasialFeedback.forEach((item: any) => {
            if (item.questionaire?.question === "SIGNIFICANT ACHIEVEMENTS") {
              feedbackItems.significantachievements = item.otherText;
            } else if (item.questionaire?.question === "IMPROVEMENT AREAS") {
              feedbackItems.improvementareas = item.otherText;
            } else if (item.questionaire?.question === "Technical Skills") {
              feedbackItems.technicalskills = item.otherText;
            } else if (item.questionaire?.question === "Soft Skills") {
              feedbackItems.softskills = item.otherText;
            } else if (item.questionaire?.question === "APPRAISER COMMENTS") {
              feedbackItems.appraisercomments = item.otherText;
            }
          });
        dispatch(storeAppraiserFeedback(feedbackItems));
        handleReviewResponse(response);
      })
      .catch((err: any) => {
        setLoader(false);
        triggerNotification("error", "", err?.message, "topRight");
      });
  }
};
